import { enrolmentMenu } from './menues/enrolmentMenu'
import { financeMenu } from './menues/financeMenu'
import { academicMenu } from './menues/academicMenu'
import { operationMenu } from './menues/operationMenu'
import { userManagementMenu } from './menues/userManageMenu'
import { assessmentMenu } from './menues/assessmentMenu'
import { corporateMenu } from './menues/corporateMenu'
import { misMenu } from './menues/misMenu'
import { fetchMenuConfig } from './menuConfigService'

const mainObject = (mainObject: any, isAssessment?: boolean) => {
  if (isAssessment) {
    const sortedObjects = Object.keys(mainObject)
      .map(key => ({ key, innerObject: mainObject[key] }))
      .reduce((acc: any, curr) => {
        acc[curr.key] = curr.innerObject

        return acc
      }, {})

    return sortedObjects
  }

  const sortedObjects = Object.keys(mainObject)
    .map(key => ({ key, innerObject: mainObject[key] }))
    .sort((a, b) => a.innerObject.title.localeCompare(b.innerObject.title))
    .reduce((acc: any, curr) => {
      acc[curr.key] = curr.innerObject

      return acc
    }, {})

  return sortedObjects
}

// Hardcoded fallback menu data (original implementation)
const hardcodedMenuData: any = {
  ...mainObject(operationMenu),
  ...mainObject(financeMenu),
  ...mainObject(academicMenu),
  ...mainObject(assessmentMenu, true),
  ...mainObject(enrolmentMenu),
  ...mainObject(userManagementMenu),
  ...mainObject(corporateMenu),
  ...mainObject(misMenu)
}

// Build MenuData from API config, applying the same sorting logic
const buildMenuDataFromConfig = (config: Record<string, any>): any => {
  const menuData: any = {}

  // Map config keys to the same order and sorting as the hardcoded version
  const menuGroupOrder = [
    { key: 'operationMenu', isAssessment: false },
    { key: 'assessmentMenu', isAssessment: true },
    { key: 'academicMenu', isAssessment: false },
    { key: 'financeMenu', isAssessment: false },
    { key: 'enrolmentMenu', isAssessment: false },
    { key: 'userManagementMenu', isAssessment: false },
    { key: 'corporateMenu', isAssessment: false },
    { key: 'misMenu', isAssessment: false }
  ]

  for (const { key, isAssessment } of menuGroupOrder) {
    if (config[key]) {
      Object.assign(menuData, mainObject(config[key], isAssessment))
    }
  }

  return menuData
}

// Start with hardcoded data, will be replaced when API data loads
export let MenuData: any = hardcodedMenuData

// Fetch menu config from API and update MenuData
// This runs once on module load; if the API fails, hardcoded data is used
fetchMenuConfig().then(config => {
  if (config) {
    MenuData = buildMenuDataFromConfig(config)
  }
}).catch(() => {
  // Silently keep using hardcoded fallback
})
